import $ from 'jquery';

// Global vars
var slider, output;
var $low, $high, $sliderLow, $sliderHigh, $sliderInput;
const diff = 50000;
let sliderOn = false;

// makes a value convert from 400000 to 400k
function kFormatter(num) {
  if(Math.abs(num) > 999999) {
    return  Math.sign(num)*((Math.abs(num)/1000000).toFixed(1)) + 'M'
  }
  if(Math.abs(num) > 999) {
    return  Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'k'
  }
  return Math.sign(num)*Math.abs(num)
}

function renderShowhomeGrid(){
  //determines length of showhomes cards. and applys full width placeholder if 0
  $( '.js-builder' ).each( function() {
    const showhomes = $(this).find('.js-showhomeCard:not(.hidden)');

    if( showhomes.length == 0 ){
      $( this).find('.js-fullWidth').show();
    } else {
      $( this).find('.js-fullWidth').hide();
    }
  })
}

function showPastShowhomes() {
  $( '.status-past' ).removeClass( 'hidden' );
}

function hidePastShowhomes() {
  $( '.status-past' ).addClass( 'hidden' );
}

// replace with commas
function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// On document
$(function() {
  if( $( '#myRange' ).length ) {
  // slider itself
  slider = document.getElementById( "myRange" );
  // slider output
  output = document.getElementById( "rangeOut" );
  //slider output range
  $low = document.getElementById( "rangeOutLower" );
  $high = document.getElementById( "rangeOutHigher" );
  // min/max of available pricepoints
  $sliderLow = document.getElementById( "sliderLow" );
  $sliderHigh = document.getElementById( "sliderHigh" );

   output.innerHTML = numberWithCommas(parseInt(slider.value)); // Display the default slider value
   $low.innerHTML = kFormatter( parseInt(slider.value) - diff );// Display the default slider value - 50000
   $high.innerHTML = kFormatter( parseInt( slider.value ) + diff );// Display the default slider value + 50000
   $sliderLow.innerHTML = kFormatter( $(slider).attr('min') );
   $sliderHigh.innerHTML = kFormatter( $(slider).attr('max') );

    // Update the current slider value ( when you lift off slider )
    slider.onchange = sliderChanged;
    slider.onmousemove = sliderDrag;
    slider.onmousedown = () => {
      sliderOn = true;
    };
    slider.onmouseup = () => {
      sliderOn = false;
    };
  }
})


const sliderDrag = function( e ) {
  if(!sliderOn) return false;

  output.innerHTML = numberWithCommas(parseInt(slider.value)); // Display the default slider value

  const $sliderInput = parseInt( slider.value )

  const low = $sliderInput - diff;
  const high = $sliderInput + diff;

  $low.innerHTML = kFormatter( low );
  $high.innerHTML = kFormatter( high );
}

const sliderChanged = function( ) {
  const $sliderInput = parseInt( slider.value )

  const low = $sliderInput - diff;
  const high = $sliderInput + diff;

  // run the slider drag too just to make sure the display is in sync
  sliderDrag();

  // when you move the slider it will show all styles, and remove any colouring
  $( '.js-style' ).show();
  $( '.js-styleMenu a' ).parent().children().removeClass('style-toggle');

  // filter with the price slider
  $( '.js-showhomeCard' ).each( function() {
    let price = $( this ).data( 'price' )
    if( price >= low && price <= high ){
      $( this ).removeClass('hidden order-last');
    } else {
      $( this ).addClass('hidden order-last');
    }
  })

  // filter by build type
  $( '.js-builder' ).each( function( index ) {
    const inRange = low <= $( this ).data( 'build-high' ) && high >= $( this ).data( 'build-low' );
    if( inRange ){
      $( this ).show();
    } else {
      $( this ).hide();
    }
  })

  // shows the error message if none are in the style
  $( '.js-style' ).each( function() {
    const numberOfBuilders = $( this ).find( '.js-builder:visible').length;
    const style = $( this ).data('style');
    if( numberOfBuilders == 0) {
      $( `#error-${style}` ).show();
    } else {
      $( `#error-${style}` ).hide();
    }
  })

  // push slider value to the data layer (need to create value trigger in analytics)
  dataLayer.push({'event': 'price_input', 'value': $sliderInput});
  renderShowhomeGrid();
}

// a simple accordion
if( $( '.showmore' ).length ) {
  $('.showmore .title').click(function(e) {
    e.preventDefault();

    var $this = $( this );
    var $accordion = $this.parent();
    var $content = $this.next();

    $accordion.parent().find( '.content' ).css( 'max-height', '0' );

    if ( $accordion.hasClass( 'open' ) ) {
      $accordion.removeClass( 'open' );
    } else {
      $accordion.siblings().removeClass( 'open' );
      $accordion.addClass( 'open' );
      $content.css( 'max-height', $content[0].scrollHeight );
    }
  })

  // filter by showhome style
  $( document ).on( 'click','.js-styleMenu a', function(e) {
    e.preventDefault();

    var $this = $( this );
    let style = $this.data( 'style' );

    $this.parent().children().removeClass('style-toggle');
    $this.addClass('style-toggle');

    $( '#past-showhomes-filter' ).prop( 'checked', false );

    $('.js-showhomeCard').removeClass('hidden')
    $('.js-builder').show()
    $('.js-fullWidth').hide()
    $('.error').hide()

    $( '.js-style' ).each( function() {
      if( $( this ).data( 'style' ) == style || style == 'all' ){
        $( this ).show().css( { opacity: 1 } );
      } else {
        $( this ).hide();
      }
    })
    // push style value to the data layer (need to create value trigger in analytics)
    dataLayer.push({'event': 'style_input', 'value': style});
    hidePastShowhomes();
    renderShowhomeGrid();
  })

  $( '#past-showhomes-filter' ).on( 'click', ( elem ) => {
    let $this = $( elem.currentTarget );
    if( $this.is( ':checked' ) ) {
      $( '.showhome-filter' ).removeClass('style-toggle');
      $( '.showhome-filter[data-style="all"]' ).addClass('style-toggle');
      $( '.showmore' ).removeClass( 'open' )
      $( '.showmore .content' ).css( 'max-height', '0' );
      showPastShowhomes();
      renderShowhomeGrid();

    } else {
      hidePastShowhomes();
      renderShowhomeGrid();
    }

    $( '.js-style' ).each( function() {
      $( this ).show().css( { opacity: 1 } );
    } )
  } )

  renderShowhomeGrid()
}

